import type { ComponentPropsWithoutRef } from "react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { DuplicatePostModalComponent } from "./DuplicatePostModalComponent";
import { DuplicatePostModalUIKitComponent } from "./DuplicatePostModalUIKitComponent";

export type DuplicatePostModalProps = ComponentPropsWithoutRef<
  typeof DuplicatePostModalUIKitComponent
>;

export const DuplicatePostModal = (props: DuplicatePostModalProps) => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");

  if (isCircleV4) {
    const { isOpen = false, onClose, ...restProps } = props;

    return (
      <DuplicatePostModalComponent
        {...restProps}
        open={isOpen}
        onOpenChange={open => {
          if (!open) {
            onClose();
          }
        }}
      />
    );
  }

  return <DuplicatePostModalUIKitComponent {...props} />;
};
